import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SpycraftCardDeck from './SpycraftCardDeck';
import { spycraftMixedArrType } from '../proptypes/spycraft';
import MoreButton from './MoreButton';

const getPagedList = (itemsPerPage, listEnd, list) => list.slice(0, itemsPerPage * listEnd);

const PagedSpycraftCardDeck = ({
  content, itemsPerPage, nextPageButtonLabel, ...props
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  return (
    <>
      <SpycraftCardDeck content={getPagedList(itemsPerPage, currentPage, content)} {...props} />
      {((itemsPerPage * currentPage) + 1 <= content.length) && (
        <div className="d-flex justify-content-center">
          <MoreButton onClick={nextPage} text={nextPageButtonLabel} />
        </div>
      )}
    </>
  );
};

PagedSpycraftCardDeck.propTypes = {
  content: spycraftMixedArrType.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  nextPageButtonLabel: PropTypes.string.isRequired,
};

export default PagedSpycraftCardDeck;
